module.exports = __webpack_public_path__ + "static/view-figma-library-c474d1284dce0f22a281f9a46386eb9b.gif";